import { atomWithReset } from 'jotai/utils'

import { type CustomerAttribute } from '~/hooks/useSurveyQuery'
import { type SurveyFilterGroups } from '~/utils'

type DialogInfo =
  | {
      dialogType: 'clone'
      customerAttribute: CustomerAttribute
    }
  | {
      dialogType: 'create'
    }
  | {
      dialogType: 'createInBulkSelectCustomerAttributes'
      filterGroupsArray: SurveyFilterGroups[]
    }
  | {
      dialogType: 'createInBulkSelectFilters'
    }
  | {
      dialogType: 'createInBulkSelectFilters2'
    }
  | {
      dialogType: 'createInBulkSelectFilters3'
    }
  | {
      dialogType: 'delete' | 'update'
      customerAttribute: CustomerAttribute
    }
  | {
      dialogType: 'deleteInBulkSelectCustomerAttributes'
    }
  | {
      dialogType: 'moveToGroup'
      customerAttribute: CustomerAttribute
    }
  | {
      dialogType: 'sort'
    }

export const dialogInfoAtom = atomWithReset<DialogInfo | null>(null)
